import {useEffect, useMemo} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { Col, Row } from "antd";
import {
	Button,
	Loading
} from "~/components";
import {
	InputField,
	GroupRadioField,
	TextAreaField,
	DateField
} from "~/components/Forms";

function SupplierFormAddEdit({item, onAdd, onUpdate})
{
	const isEdit = Boolean(item?.id);

	const initialValues = useMemo(
		() => ({
			code: item?.code ?? "",
			name: item?.name ?? "",
			email: item?.email ?? "",
			phone: item?.phone ?? "",
			address: item?.address ?? "",
			note: item?.note ?? "",
			contractDate: item?.contractDate ? item?.contractDate*1000 : null,
			expireDate: item?.expireDate ? item?.expireDate*1000 : null,
		}),
		[item]
	);

	const validationSchema = Yup.object().shape({
		code: Yup.string().nullable().required('Bạn điền mã nhà cung cấp'),
		name: Yup.string().nullable().required('Bạn điền mã nhà cung cấp'),
		email: Yup.string().email('Email không đúng định dạng').required('Email không được để trống'),
		address: Yup.string().required('Địa chỉ không được để trống'),
	})

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() =>
	{
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) =>
	{
		const submitData = {
			...data,
			contractDate: data.contractDate ? Math.floor(data.contractDate / 1000) : null,
			expireDate: data.expireDate ? Math.floor(data.expireDate / 1000) : null,
		};

		if(isEdit)
		{
			await onUpdate(submitData, item);
		}
		else
		{
			await onAdd(submitData);
		}
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Thông tin nhà cung cấp</p>
			<Row gutter={10}>
				<Col span={12}>
					<Controller control={control} name="code" render={({ field }) => (
						<InputField
							label={"Mã nhà cung cấp"}
							errors={errors}
							{...field}
						/>
					)} />
				</Col>
				<Col span={12}>
					<Controller control={control} name="name" render={({ field }) => (
						<InputField
							label={"Tên nhà cung cấp"}
							errors={errors}
							{...field}
						/>
					)} />
				</Col>
			</Row>
			<p className="heading mt-2">Thông tin liên hệ</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="email" render={({field}) => (
						<InputField type="email" label="Email liên hệ" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="phone" render={({field}) => (
						<InputField type="tel" label="Số điện thoại" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<Row gutter={10}>
				<Col className="gutter-row" span={24}>
					<Controller control={control} name="address" render={({field}) => (
						<InputField label="Địa chỉ" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<p className="heading mt-2">Thông tin thêm</p>
			<Row gutter={10}>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="contractDate" render={({ field }) => (
						<DateField label="Ngày kí hợp đồng" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={12}>
					<Controller control={control} name="expireDate" render={({ field }) => (
						<DateField label="Ngày hạn hợp đồng" errors={errors} {...field}/>
					)}/>
				</Col>
				<Col className="gutter-row" span={24}>
					<Controller control={control} name="note" render={({field}) => (
						<TextAreaField label="Ghi chú" errors={errors} {...field}/>
					)}/>
				</Col>
			</Row>
			<div className="form-group d-flex justify-content-end">
				<Button primary type="submit">{isEdit ? 'Cập nhật' : 'Thêm nhà cung cấp'}</Button>
			</div>
		</form>
	)
}

export default SupplierFormAddEdit;